import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import theme from '../../theme';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const FAQS = [
  {
    q: 'How does deduplication work across channels?',
    a: 'Each conversion is matched against every touchpoint using your first-party customer IDs, so a single conversion is only ever counted once — even if five channels each independently claim it.',
  },
  {
    q: 'Which attribution models are supported?',
    a: 'First-touch, last-touch, linear, time-decay, and a custom blended model, all across multiple lookback windows. Switch models without re-tagging anything.',
  },
  {
    q: 'What is post-impression attribution?',
    a: "Credit for conversions driven by an ad someone saw but didn't click — sourced directly from your adserver and reconciled against GA4, so display and video get real credit.",
  },
  {
    q: 'Do I need GA4 connected?',
    a: 'Yes — GA4 is the source for on-site behaviour; the adserver integration adds the impression side so both click and view-through activity feed the models.',
  },
];

export default function AttributionFAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <View
      style={{
        paddingHorizontal: theme.spacing.space12,
        paddingTop: theme.spacing.space10,
        paddingBottom: theme.spacing.space16,
        maxWidth: 760,
        alignSelf: 'center',
        width: '100%',
        borderTopWidth: theme.borderWidth.thin,
        borderTopColor: theme.colors.borderSubtle,
      }}
    >
      <Text
        style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: theme.typography.size['2xl'],
          letterSpacing: theme.trackingPx(theme.typography.size['2xl'], 'tight'),
          color: theme.colors.textPrimary,
          marginBottom: theme.spacing.space6,
        }}
      >
        FAQ
      </Text>

      {FAQS.map((item, i) => {
        const isOpen = i === openIndex;
        return (
          <Pressable
            key={item.q}
            onPress={() => setOpenIndex(isOpen ? -1 : i)}
            style={{
              borderBottomWidth: theme.borderWidth.thin,
              borderBottomColor: theme.colors.borderDefault,
              paddingVertical: theme.spacing.space4 + 2,
            }}
          >
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: theme.spacing.space4 }}>
              <Text
                style={{
                  flex: 1,
                  fontFamily: theme.typography.fontBody,
                  fontWeight: theme.typography.weight.medium,
                  fontSize: theme.typography.size.base,
                  color: theme.colors.textPrimary,
                }}
              >
                {item.q}
              </Text>
              {isOpen ? (
                <RemoveIcon style={{ fontSize: 18, color: theme.colors.textTertiary, flexShrink: 0 }} />
              ) : (
                <AddIcon style={{ fontSize: 18, color: theme.colors.textTertiary, flexShrink: 0 }} />
              )}
            </View>
            {isOpen && (
              <Text
                style={{
                  fontFamily: theme.typography.fontBody,
                  fontSize: theme.typography.size.sm,
                  color: theme.colors.textSecondary,
                  lineHeight: theme.lineHeightPx(theme.typography.size.sm, 'normal'),
                  marginTop: theme.spacing.space3,
                  maxWidth: 620,
                }}
              >
                {item.a}
              </Text>
            )}
          </Pressable>
        );
      })}
    </View>
  );
}
